export default function fileEpsSvg () {
  return `
    <svg id="file-eps-svg">
      <use xlink:href="/img/icons/file-eps.svg#file-eps-svg" width="160" height="130"></use>
    </svg>
  `
}
